import { Action } from '../../../core/types';
import * as ActionTypes from './actionTypes';
import { AppState, LoginFormError } from './types';

export const initialState = {
  error: {},
  form: {
    email: '',
    password: '',
  },
  loaded: false,
  submit: false,
};

export default function appReducer(state: AppState = initialState, action: Action) {
  switch (action.type) {
    case ActionTypes.APP_LOGIN_SHOW:
      return {
        ...state,
        loaded: true,
      };
    case ActionTypes.APP_LOGIN_EMAIL_UPDATE: {
      const { email } = action.payload;
      const form = state.form;
      return {
        ...state,
        form: {
          ...form,
          email,
        },
      };
    }
    case ActionTypes.APP_LOGIN_PASSWORD_UPDATE: {
      const { password } = action.payload;
      const form = state.form;
      return {
        ...state,
        form: {
          ...form,
          password,
        },
      };
    }
    case ActionTypes.APP_LOGIN_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        submit: false,
        error: {
          ...state.error,
          [error.field]: error.error,
        },
      };
    }
    case ActionTypes.APP_LOGIN_ERROR_CLEAN: {
      // clean error for given field
      const { field } = action.payload;
      const error: LoginFormError = {
        ...state.error,
      };
      delete error[field as keyof LoginFormError];
      return {
        ...state,
        error,
      };
    }
    case ActionTypes.APP_LOGIN_SUBMIT: {
      return {
        ...state,
        submit: true,
      };
    }
    case ActionTypes.APP_LOGIN_SUCCESS: {
      return {
        ...state,
        submit: false,
      };
    }
    default:
      return state;
  }
}
